import styled from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';
import FastImage from '../../Interface/Images/FastImageWithFallback';

import {Platform} from 'react-native';
import {css} from 'styled-components';
import LinearGradient from 'react-native-linear-gradient';

export const SavedContainer = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 0 24px;

  border-radius: ${RFValue(14)}px;
  z-index: 9999;
  margin-top: -${RFValue(30)}px;
  background-color: ${({theme}) => theme.colors.background};

  ${({}) =>
    Platform.OS !== 'android'
      ? css`
          shadow-color: rgba(0, 0, 0, 0.5);
          shadow-offset: 0px 4px;
          shadow-opacity: 0.1;
          shadow-radius: 9px;
        `
      : css``}
`;

export const SavedContainerFooterInfo = styled(LinearGradient).attrs(
  ({theme}) => ({
    colors: theme.colors.promo_marquee_bg,
  }),
)`
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: ${RFValue(4)}px;
  margin: 0 24px;
  padding: ${RFValue(4)}px ${RFValue(12)}px;
  padding-top: ${RFValue(14)}px;
  margin-top: -${RFValue(12)}px;
  border-bottom-left-radius: ${RFValue(14)}px;
  border-bottom-right-radius: ${RFValue(14)}px;
`;

export const SavedIcon = styled(FastImage)`
  width: ${RFValue(16)}px;
  height: ${RFValue(16)}px;
`;
export const SavedContainerFooterInfoText = styled.Text`
  color: ${({theme}) => theme.colors.shape};
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(10)}px;
  text-align: center;
`;

export const SavedContent = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  padding: ${RFValue(10)}px ${RFValue(12)}px;
`;

export const SavedContentContainer = styled.View``;

export const SavedTitle = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(11)}px;

  font-family: ${({theme}) => theme.fonts.regular};
`;
export const AmountTitle = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(15)}px;
  margin-top: -${RFValue(2)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const PiggyContainer = styled.View`
  margin-top: -${RFValue(14)}px;
`;
